import UserMixin from "@godweb/frontend-base/src/mixins/user/UserMixin";

export default {
  mixins: [UserMixin],
  props: {
    needDownload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    eventKey() {
      return `button_click_${process.env.VUE_APP_PROMO}`;
    },
    lsKey() {
      return `storage_${process.env.VUE_APP_PROMO}`;
    },
  },
  mounted() {
    // if event is registered
    if (this.$eventBroker.getEvent(this.eventKey)) {
      // trigger button click when event has been triggered
      this.$eventBroker.subscribeToEvent(this.eventKey).then(() => {
        this.handleButtonClick("register", true);
      });
    }
  },
  methods: {
    // eslint-disable-next-line
    handleButtonClick(loginMethod = "register", autoclick = false) {
      const download_method = autoclick ? "checkStorageAndDownload" : "gameDownload";

      if (this.isUserInProject) {
        this.needDownload ? this[download_method]() : this.redirect();
      } else {
        if (this.isWindowsOs) {
          this.$eventBroker.registerEvent({
            key: this.eventKey,
            type: "after_reg",
          });
        }
        this.changeAccount();
      }
    },
    checkStorageAndDownload() {
      if (!localStorage.getItem(this.lsKey)) {
        if (!!window.__GEM) {
          this.gameDownload();
        } else {
          document.addEventListener("GEM_loaded", () => {
            this.gameDownload();
          });
        }
        localStorage.setItem(this.lsKey, true);
      }
    },
    redirect() {
      window.location.href = this.isSteamUser
        ? "https://store.steampowered.com/app/1491000"
        : window.location.origin;
    },
    redirectToStore(isBlank) {
      const target = isBlank ? "_blank" : "_self";
      if (this.isSteamUser) {
        this.$oneLinkEventSender.sendEvent("steam");
        window.open("https://warrobotsfrontiers.com/l/steam", target);
      }

      if (this.isXboxUser) {
        this.$oneLinkEventSender.sendEvent("xbox");
        window.open("https://warrobotsfrontiers.com/l/xbox", target);
      }

      if (this.isPSUser) {
        this.$oneLinkEventSender.sendEvent("playstation");
        window.open("https://warrobotsfrontiers.com/l/playstation", target);
      }
    },
    redirectToMGStore(isBlank) {
      const target = isBlank ? "_blank" : "_self";
      this.$oneLinkEventSender.sendEvent("MY.GAMES");
      window.open("https://my.games/play/war_robots_frontiers_mg", target);
    },
  },
};
